<template>
    <div class="view view__lms_superadmin_workspace_edit_selfregistration_add">
       <lms-superadmin-workspace-edit-self-registration-add ref="childcomponent"/>
    </div>
</template>

<script>
import LmsSuperadminWorkspaceEditSelfRegistrationAdd
  from '@/components/lms/superadmin/workspace/edit/LmsSuperadminWorkspaceEditSelfRegistrationAdd'
import { validateAllowRedirectBeforeRouteLeave } from '@/helpers/mixins'

export default {
  components: { LmsSuperadminWorkspaceEditSelfRegistrationAdd },
  name: 'view-lms-superadmin-workspace-edit-self-registration-add',
  mixins: [validateAllowRedirectBeforeRouteLeave],
  methods: {
    clearWorkspaceKey () {
      this.$store.dispatch('lmsSuperadminWorkspaceKeyClear')
    }
  },
  created () {
    this.clearWorkspaceKey()
  },
  inject: ['$validator']
}
</script>
